import React, { useContext } from 'react';
import { bool, string } from 'prop-types';
import { Image } from '@thd-olt-component-react/core-ui';
import { OrderAPackageContext } from '../../../OrderAPackageContext';
import './addOrRemoveButton.scss';

export const AddOrRemoveButton = ({ itemId, productGroupSelected, className }) => {
  const { dispatch, actions, state } = useContext(OrderAPackageContext);
  const { selectedProductIds } = state;
  const handlePodInteraction = () => {
    dispatch(actions.togglePodInteraction(itemId));
  };

  if (selectedProductIds.length <= 1 && productGroupSelected) return null;

  return (
    <button id={itemId} className={`${className} add-or-remove-button`} onClick={handlePodInteraction} type="button">
      { productGroupSelected ?
        (
          <>
            <Image
              className="add-or-remove-button__trash-can"
              src="https://assets.thdstatic.com/images/v1/trash-default.svg"
              alt="Trash can icon to remove item from package."
              width={1}
              height={1}
            />
            <span className="add-or-remove-button__text">Remove </span>
          </>
        )
        :
        (
          <>
            <span className="add-or-remove-button__plus-symbol">+</span>
            <span className="add-or-remove-button__text">Add to Bundle</span>
          </>
        )
      }{/* eslint-disable-line */}
    </button>
  );
};

AddOrRemoveButton.propTypes = {
  itemId: string.isRequired,
  productGroupSelected: bool.isRequired,
  className: string
};

AddOrRemoveButton.defaultProps = {
  className: ''
};

AddOrRemoveButton.displayName = 'AddOrRemoveButton';
